<div class="row section1">
    <div class="col-12 col-md-7 col-lg-7 col-xl-7">
        <div class="home-details">
            <h5 class="home-title">{{heading}}</h5>
            <p class="home-subtitle">{{subHeading}}</p>
        </div>
    </div>
    <div class="col-12 col-md-7 col-lg-5 col-xl-5">
        <div class="dashboard-btn dashboard-manage">
            <div><a (click)="goBack()">
                <button class="btn btn-primary btn-dashboard">Back</button>
            </a></div>
        </div>
    </div>
</div>
